export { HeroTabs } from './hero-tabs'
